import * as React from "react";

import * as S from "@styled";
import { isEmptyObject } from "shared/utilities";
import CustomModal from "shared/components/CustomModal";

interface IDeleteModalProps {
    show: boolean;
    elementsToDelete: {id: number, name: string}[];
    onDelete: (ids: number[]) => void;
    onClose: () => void;
    blockDelete: boolean;
    modalWarningLabel: string;
    warnings: {
        [name: string]: {
            [version: string]: string[]
        }
    }
}

const DeleteModal: React.FC<IDeleteModalProps> = (props) => {
    if (!props.show) {
        return null;
    }

    const handleDelete = () => {
        props.onDelete(props.elementsToDelete.map(x => x.id));
    };

    const deleteConfirmationMessage = () => {
        if (props.blockDelete) {
            return "";
        }

        if (props.elementsToDelete.length <= 0) {
            return <div>No elements</div>;
        }

        return (
            <S.WarningContainer>
                <div className="alert-warning">
                    <div className="alert-label">
                        {props.elementsToDelete.length > 1 ? FRENDS.Localizations.Confirm_DeleteMultiple : FRENDS.Localizations.Confirm_Delete}
                    </div>
                    <div className="alert-content">
                        <div className="cascading-delete">
                            {props.elementsToDelete.map(x => <p key={x.id}><b>{x.name}</b></p>)}
                        </div>
                    </div>
                </div>
            </S.WarningContainer>
        )
    };

    return (
        <CustomModal
            label="confirmDelete"
            onClose={props.onClose}
            shouldCloseOnOverlayClick={true}
            show={props.show}
            modalTitle={<h2>{FRENDS.Localizations.Delete}</h2>}
        >
            {(!isEmptyObject(props.warnings)) ?
                <S.ErrorContainer>
                    <div className="alert-warning">
                        <div className="alert-label">{props.modalWarningLabel}</div>
                        <div className="alert-content">
                            {Object.keys(props.warnings).map((name) =>
                                <React.Fragment key={name}>
                                    {name}
                                    {Object.keys(props.warnings[name]).map((version) =>
                                        <p key={name + version}>{version} - {props.warnings[name][version].join(", ")}</p>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </S.ErrorContainer>
                : null}
            
            {deleteConfirmationMessage()}
            
            <S.ButtonGroup $justifyContentEnd={true} gap={10}>
                <S.Button variant={S.ButtonType.bordered} onClick={props.onClose}>
                    {FRENDS.Localizations.Cancel}
                </S.Button>
                <S.Button disabled={props.blockDelete} onClick={handleDelete}>
                    {FRENDS.Localizations.Delete}
                </S.Button>
            </S.ButtonGroup>
        </CustomModal>
    );
};

export default DeleteModal;